














































































































































































































import { Component, Vue } from "vue-property-decorator";
import { MediaInterfaces } from "@/resources/interfaces/mediaInterfaces";
import Chime from "@/resources/mixins/chime/chime";
import SkipTutorialComponent from "@/app/components/onboarding/skipTutorial/skipTutorial.component.vue";
import { mixins } from "vue-class-component";
import LoadApp from "@/resources/mixins/loadApp/loadApp";
import GraphicClient from "@/resources/mixins/graphicClient/graphicClient";
import { BOT_CHAT } from "@/resources/constants/botChat";
import {
  MessageType,
  UserSendMessageType,
} from "@/resources/constants/graphicClient/graphicClient";
import { i18n } from "@/resources/locales";
import DeviceController from "@/resources/mixins/deviceController/deviceController";
import PermissionController from "@/resources/mixins/permissionController/permissionController";
@Component({
  name: "config-devices-component",
})
export default class VideoAudioComponent extends mixins(
  LoadApp,
  Chime,
  DeviceController,
  PermissionController
) {
  BOT_CHAT = BOT_CHAT;
  permissions = "prompt";
  mediaDevicesList: Array<MediaInterfaces> = [];
  audioInputDeviceAux = "";
  videoInputDeviceAux = "";
  audioOutputDeviceAux = "";
  audioStream: MediaStream | null = null;
  videoStream: HTMLVideoElement | null = null;
  localStream: MediaStream | null = null;
  camera = "";
  skip = false;
  notClose = true;
  videoElement: HTMLElement = null;
  constructor() {
    super();
    this.checkPermissions(this.callbackPermission);
  }
  updated(): void {
    this.videoElement = document.getElementById("video-preview");
  }
  destroyed(): void {
    this.onClose();
  }
  async allowPermissions(): Promise<void> {
    this.permissions = "pending";
    await this.setDevices();
  }
  async setDevices(): Promise<void> {
    const deviceList = await navigator.mediaDevices
      .enumerateDevices()
      .then((devices) => devices);
    this.mediaDevicesList = JSON.parse(JSON.stringify(deviceList));
    navigator.mediaDevices
      .getUserMedia({
        audio: {
          deviceId: this.audioInputDevice || "",
        },
        video: {
          deviceId: this.videoInputDevice || "",
        },
      })
      .then((result) => {
        this.addStream(result);
        this.localStream = result;
      });
    let videoDevice = this.$store.getters["MeetingStore/getSelectedVideoInput"];
    if (!videoDevice) {
      videoDevice = localStorage.getItem("PREFERRED_VIDEO_INPUT");
    }

    let audioDevice = this.$store.getters["MeetingStore/getSelectedAudioInput"];
    if (!audioDevice) {
      audioDevice = localStorage.getItem("PREFERRED_AUDIO_INPUT");
    }
    /*  */
    let audioOutputDevice =
      this.$store.getters["MeetingStore/getSelectedAudioOutput"];
    if (!audioOutputDevice) {
      audioOutputDevice = localStorage.getItem("PREFERRED_AUDIO_OUTPUT");
    }
    if (
      videoDevice &&
      this.checkDeviceIsAvailable(videoDevice) &&
      this.checkDeviceIsAvailable(audioDevice) &&
      this.checkDeviceIsAvailable(audioOutputDevice)
    ) {
      this.audioInputDevice = audioDevice || "";
      this.videoInputDevice = videoDevice || "";
      this.audioOutputDevice = audioOutputDevice || "";
    } else {
      /*  */
      const audioDevices = this.getInputDevices("audioinput");
      this.audioInputDevice =
        audioDevices.length > 0 ? audioDevices[0].deviceId : "";
      /*  */
      const audioOutputDevices = this.getInputDevices("audiooutput");
      this.audioOutputDevice =
        audioOutputDevices.length > 0 ? audioOutputDevices[0].deviceId : "";
      /*  */
      const videoDevices = this.getInputDevices("videoinput");
      this.videoInputDevice =
        videoDevices.length > 0 ? videoDevices[0].deviceId : "";
    }
  }
  checkDeviceIsAvailable(deviceId: string): boolean {
    return this.mediaDevicesList.some((a) => a.deviceId === deviceId);
  }
  getInputDevices(type: string): Array<MediaInterfaces> {
    return this.mediaDevicesList.filter((dev) => dev.kind === type);
  }
  async updateDevices(): Promise<void> {
    const videoDevices: Array<MediaInterfaces> = [];
    const audioDevices: Array<MediaInterfaces> = [];
    const audioOutputDevices: Array<MediaInterfaces> = [];

    const deviceList = await navigator.mediaDevices
      .enumerateDevices()
      .then((devices) => devices);
    this.mediaDevicesList = JSON.parse(JSON.stringify(deviceList));

    if (this.videoInputDevice === "" || this.audioInputDevice === "") {
      this.mediaDevicesList.forEach((dev) => {
        if (dev.kind === "videoinput") videoDevices.push(dev);
        if (dev.kind === "audioinput") audioDevices.push(dev);
        if (dev.kind === "audiooutput") audioOutputDevices.push(dev);
      });

      if (this.videoInputDevice === "")
        this.videoInputDevice = videoDevices[0].deviceId;

      if (this.audioInputDevice === "")
        this.audioInputDevice = audioDevices[0].deviceId;

      if (this.audioOutputDevice === "")
        this.audioOutputDevice = audioOutputDevices[0].deviceId;
    }
    this.notClose = false;
  }
  async displayVideoPreview(): Promise<void> {
    setTimeout(async () => {
      const video = document.getElementById("video-preview");
      if (video instanceof HTMLVideoElement) {
        try {
          video.srcObject = await navigator.mediaDevices.getUserMedia({
            video: {
              deviceId: this.videoInputDevice || "",
            },
          });
          this.addVideoStream(video);
          this.videoStream = video;
        } catch (error) {
          this.notClose = false;
        }
        try {
          await video.play().then();
        } catch (e) {
          this.notClose = false;
        }
        await this.updateDevices();
      }
      this.notClose = false;
    }, 200);
  }
  async displayAudioPreview(): Promise<void> {
    const audioContext = window.AudioContext ? new window.AudioContext() : null;
    if (audioContext) {
      audioContext.resume().then(async () => {
        const analyser = audioContext.createAnalyser();
        analyser.fftSize = 1024;
        analyser.smoothingTimeConstant = 0.5;

        const stream = await navigator.mediaDevices.getUserMedia({
          audio: {
            deviceId: this.audioInputDevice || "",
          },
        });
        if (stream) this.addAudioStream(stream);
        if (this.audioStream) return;
        this.audioStream = stream;
        const source = audioContext?.createMediaStreamSource(stream);
        source?.connect(analyser);
        const samples = new Uint8Array(analyser.frequencyBinCount);

        const track = stream.getTracks()[0];
        let level = 0;

        function rootMeanSquare(samp) {
          const sumSq = samp.reduce((sumSqr, s) => sumSqr + s * s, 0);
          return Math.sqrt(sumSq / samp.length);
        }

        requestAnimationFrame(function checkLevel() {
          const maxLevel = 500;

          analyser.getByteFrequencyData(samples);
          const rms = rootMeanSquare(samples);
          const log2Rms = rms && Math.log2(rms);
          const newLevel = Math.ceil((maxLevel * log2Rms) / 8);

          if (level !== newLevel) {
            level = newLevel;

            const displayLevel = (level * 10) / maxLevel;
            const audioPreviewContainer = document.getElementById(
              "audio-preview-container"
            );
            if (audioPreviewContainer) {
              const volumeIndicators =
                audioPreviewContainer.getElementsByTagName("span");
              for (let i = 0; i < volumeIndicators.length; i += 1) {
                if (i > displayLevel) {
                  volumeIndicators[i].className = "mic-preview-level";
                } else {
                  if (i > volumeIndicators.length - 3)
                    volumeIndicators[i].className = "mic-preview-level-hard";
                  else if (i > volumeIndicators.length / 3)
                    volumeIndicators[i].className = "mic-preview-level-medium";
                  else
                    volumeIndicators[i].className = "mic-preview-level-active";
                }
              }
            }
          }
          requestAnimationFrame(
            track.readyState === "ended" ? () => null : checkLevel
          );
        });
      });
    }
  }
  stopTracks(): void {
    try {
      this.removeVideoStream();
      this.removeAudioStream();
      this.checkDevicesActive();

      const meetingSession =
        this.$store.getters["MeetingStore/getMeetingSession"];
      const isCall = this.$store.getters["SidebarStore/getOpenCall"];
      if (meetingSession && !isCall) {
        meetingSession.audioVideo.realtimeMuteLocalAudio();
        meetingSession.audioVideo.stopLocalVideoTile();
        meetingSession.audioVideo.stop();

        meetingSession.audioVideo.stopVideoInput();
        meetingSession.audioVideo.stopAudioInput();
        meetingSession.deviceController.destroy();
      }

      this.localStream = null;
      this.audioStream = null;
      this.videoStream = null;
    } catch (e) {
      console.log(e);
    }
  }
  async saveSelectedDevices(): Promise<void> {
    await this.$store.dispatch(
      "MeetingStore/setSelectedAudioInputAction",
      this.audioInputDevice
    );
    await this.$store.dispatch(
      "MeetingStore/setSelectedAudioOutputAction",
      this.audioOutputDevice
    );
    await this.$store.dispatch(
      "MeetingStore/setSelectedVideoInputAction",
      this.videoInputDevice
    );

    if (this.audioInputDevice)
      localStorage.setItem("PREFERRED_AUDIO_INPUT", this.audioInputDevice);
    if (this.audioOutputDevice)
      localStorage.setItem("PREFERRED_AUDIO_OUTPUT", this.audioOutputDevice);
    if (this.videoInputDevice)
      localStorage.setItem("PREFERRED_VIDEO_INPUT", this.videoInputDevice);

    const meetingSession =
      this.$store.getters["MeetingStore/getMeetingSession"];
    if (meetingSession) {
      try {
        await this.setMeetingAudioInputDevice(meetingSession, this.$store);
        await this.setMeetingVideoInputDevice(meetingSession, this.$store);
        await this.updateBindAudioOutput(meetingSession, this.$store);
      } catch (error) {
        // do nothing
      }
    }
    await this.$store.dispatch("MeetingStore/setCameraEnabledAction", false);
    this.onSuccess(
      i18n.t("notifications.titles.success"),
      i18n.t("notifications.descriptions.videoAudio")
    );
  }

  get audioInputDevice(): string {
    return this.audioInputDeviceAux;
  }
  set audioInputDevice(device: string) {
    this.audioInputDeviceAux = device;
    this.displayAudioPreview();
  }

  get audioOutputDevice(): string {
    return this.audioOutputDeviceAux;
  }
  set audioOutputDevice(device: string) {
    this.audioOutputDeviceAux = device;
  }

  get videoInputDevice(): string {
    return this.videoInputDeviceAux;
  }
  set videoInputDevice(device: string) {
    this.videoInputDeviceAux = device;
    this.displayVideoPreview();
  }
  get getVideoDevices(): Array<MediaInterfaces> {
    return this.mediaDevicesList.filter((dev) => dev.kind === "videoinput");
  }
  get getAudioDevices(): Array<MediaInterfaces> {
    return this.mediaDevicesList.filter((dev) => dev.kind === "audioinput");
  }

  get getAudioOutputDevices(): Array<MediaInterfaces> {
    return this.mediaDevicesList.filter((dev) => dev.kind === "audiooutput");
  }

  onBoarding(): boolean {
    return this.$store.getters["SystemStore/getShowCompleteOnBoarding"];
  }
  onClose() {
    this.setGrazing();
    this.stopTracks();
    this.closeSelector();
    this.$store.dispatch("MeetingStore/setOpenDevicesConfigAction", false);
    const onBoarding =
      this.$store.getters["SystemStore/getShowCompleteOnBoarding"];
    if (onBoarding) {
      const noti = this.$vs.notification({
        duration: "none",
        clickClose: true,
        buttonClose: false,
        content: SkipTutorialComponent,
        onClick: async () => {
          const spaceUser = this.$store.getters["UserStore/getSpaceUser"];
          await this.$store.dispatch("UserStore/updateUserAction", {
            userId: spaceUser.superSpaceUser.user.id,
            props: {
              isFirstTime: false,
            },
            callback: async (user) => {
              await this.$store.dispatch(
                "SystemStore/setShowCompleteOnBoardingAction",
                false
              );
              await this.$store.dispatch(
                "SystemStore/setShowCompleteOnBoardingTeamsAction",
                false
              );
              await this.$store.dispatch(
                "SystemStore/setShowTutorialModalAction",
                false
              );
              setTimeout(async () => {
                await this.setStore(this.$store);
                await this.loadFirstTime();

                await this.$store.dispatch(
                  "SystemStore/setShowTutorialModalAction",
                  false
                );
              }, 2000);
            },
          });
        },
      });
      this.$store.dispatch("SystemStore/setNotificationTutorialAction", noti);
    }
  }
  closeSelector(): void {
    const selectOptionsPrimary = document.getElementsByClassName(
      "vs-select__options vs-component--primary"
    );
    if (selectOptionsPrimary)
      while (selectOptionsPrimary.length > 0) {
        selectOptionsPrimary[0].parentNode.removeChild(selectOptionsPrimary[0]);
      }
  }
  setGrazing(): void {
    const spaceUser = this.$store.getters["UserStore/getSpaceUser"];
    const hasOnboarding = localStorage.getItem("hasOnboarding");
    const alwaysGrazing = localStorage.getItem("alwaysGrazing");
    const room = localStorage.getItem("room");
    if (
      (room && spaceUser.isFirstTime && hasOnboarding == "false") ||
      (room && alwaysGrazing == "true")
    ) {
      this.$store.dispatch("SpaceStore/getRoomGrazingAction", {
        roomId: room,
        callback: (response) => {
          GraphicClient.sendMessage(
            MessageType.USER,
            UserSendMessageType.MOVE_LOCAL_USER,
            {
              graphicClientRoomId: response.graphicClientRoomId,
              id: response.id,
            }
          );
          localStorage.removeItem("room");
          localStorage.removeItem("alwaysGrazing");
        },
        callbackError: (error) => {
          localStorage.removeItem("room");
          localStorage.removeItem("alwaysGrazing");
        },
      });
    }
  }
  async callbackPermission(result) {
    if (result) {
      await this.addStream(result);
      this.localStream = result;
    }
    await this.setDevices();
  }
}
